import { type BootstrapStatus } from "../store/schema/YammerBootstrapStore";
import getStore from "../store/store";

export default function isYammerReady(): boolean {
    return getStore().bootstrapStatus == 2;
}
